/* Brave Bottoms: UpAiry-style pickers on Kaching's pack picker, plus print photos on the long-form page.
   - Each pair row gets a print button (round photo of the print + name + arrow) that opens a list of every
     print with its photo, and S / M / L size buttons. Kaching's own dropdowns stay in the page, hidden:
     every pick is written into them and announced with a "change" event, so Kaching's cart logic is untouched.
   - Long-form offer boxes: fills the print swatches.
   The product's variants have no images, so the photos come from the print cut-outs in Shopify Files
   (brave-bottoms-print-<print name>-cutout.png).
   2026-10-12: the print list now follows its button while the page scrolls (it used to close on any scroll or
   resize, which on phones fires when the address bar moves) and only closes on a real tap outside it. */
(() => {
  if (window.__bbSwatch) return;
  window.__bbSwatch = true;

  const slug = (name) => String(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  // Absolute address: a relative one can resolve against the stylesheet's host instead of the store
  const fileUrl = (name) => `${location.origin}/cdn/shop/files/brave-bottoms-print-${slug(name)}-cutout.png?width=160`;
  const attr = (value) => String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

  // Remember which prints have a photo
  const status = {};
  const withPhoto = (name, done) => {
    const key = slug(name);
    if (!key) return done(false);
    if (status[key] === true || status[key] === false) return done(status[key]);
    if (status[key]) return status[key].push(done);
    status[key] = [done];
    const img = new Image();
    img.onload = () => { const queue = status[key]; status[key] = true; queue.forEach((fn) => fn(true)); };
    img.onerror = () => { const queue = status[key]; status[key] = false; queue.forEach((fn) => fn(false)); };
    img.src = fileUrl(name);
  };
  const setPhoto = (el, name) => {
    if (el.dataset.bbkFor === name) return;
    el.dataset.bbkFor = name;
    withPhoto(name, (ok) => {
      if (el.dataset.bbkFor !== name) return;
      el.style.backgroundImage = ok ? `url("${fileUrl(name)}")` : 'none';
      el.classList.toggle('bbk-sw--none', !ok);
    });
  };

  const SIZE_SHORT = { small: 'S', medium: 'M', large: 'L', 'x-large': 'XL', 'extra large': 'XL', xl: 'XL', xs: 'XS', 'x-small': 'XS' };
  const sizeShort = (value) => {
    const key = String(value).toLowerCase().trim();
    return SIZE_SHORT[key] || String(value).trim().split(/[\s(/]/)[0].slice(0, 3).toUpperCase();
  };

  const CARET = '<svg class="bbk-caret" viewBox="0 0 10 6" width="10" height="6" aria-hidden="true" focusable="false"><path d="M0 0h10L5 6z" fill="currentColor"/></svg>';
  const TICK = '<svg class="bbk-tick" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const pick = (select, value) => {
    if (!select || select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  /* ---------- Kaching rows ---------- */
  function buildRow(content) {
    const print = content.querySelector('select[data-name="Print"]');
    const size = content.querySelector('select[data-name="Size"]');
    if (!print && !size) return;
    let ui = content.querySelector(':scope > .bbk-ui');
    if (!ui) {
      ui = document.createElement('div');
      ui.className = 'bbk-ui';
      if (print) {
        ui.insertAdjacentHTML('beforeend', `<button type="button" class="bbk-print" aria-haspopup="listbox" aria-expanded="false"><span class="bbk-sw" aria-hidden="true"></span><span class="bbk-name"></span>${CARET}</button>`);
      }
      if (size) ui.insertAdjacentHTML('beforeend', '<div class="bbk-sizes" role="radiogroup" aria-label="Size"></div>');
      content.appendChild(ui);
    }
    if (!content.hasAttribute('data-bbk')) content.setAttribute('data-bbk', '');

    if (print) {
      const button = ui.querySelector('.bbk-print');
      const name = button.querySelector('.bbk-name');
      if (name.textContent !== print.value) {
        name.textContent = print.value;
        button.setAttribute('aria-label', `Print: ${print.value}. Tap to change`);
      }
      setPhoto(button.querySelector('.bbk-sw'), print.value);
    }
    if (size) {
      const wrap = ui.querySelector('.bbk-sizes');
      const options = Array.from(size.options);
      const key = options.map((o) => o.value + (o.disabled ? '!' : '')).join('|');
      if (wrap.dataset.key !== key) {
        wrap.dataset.key = key;
        wrap.innerHTML = options.map((o) =>
          `<button type="button" class="bbk-size" role="radio" data-value="${attr(o.value)}" title="${attr(o.text)}" aria-label="${attr(o.text)}"${o.disabled ? ' disabled' : ''}>${attr(sizeShort(o.text))}</button>`
        ).join('');
      }
      wrap.querySelectorAll('.bbk-size').forEach((b) => {
        const on = b.dataset.value === size.value;
        if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
    }
  }

  function paintKaching() {
    document.querySelectorAll('.kaching-bundles__bar-variant__content').forEach(buildRow);
  }

  /* ---------- print list ---------- */
  let pop = null;
  let popTrigger = null;
  let popWidth = 0;
  let popFrame = 0;
  const touchScreen = () => window.matchMedia('(pointer: coarse)').matches;

  function closePop(returnFocus) {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    if (popTrigger) {
      popTrigger.setAttribute('aria-expanded', 'false');
      if (returnFocus && popTrigger.isConnected) popTrigger.focus({ preventScroll: true });
    }
    popTrigger = null;
    cancelAnimationFrame(popFrame);
    document.removeEventListener('click', onOutside, true);
    document.removeEventListener('keydown', onEscape, true);
    window.removeEventListener('scroll', onScroll, true);
    window.removeEventListener('resize', onResize);
  }
  // A tap outside closes the list. Scrolling or swiping does not: browsers send no click after a scroll gesture.
  const onOutside = (event) => {
    if (!pop || pop.contains(event.target) || (popTrigger && popTrigger.contains(event.target))) return;
    closePop(false);
  };
  const onEscape = (event) => { if (event.key === 'Escape') closePop(true); };
  // Keep the list attached to its button while the page scrolls; close it only once the button leaves the screen
  const follow = () => {
    cancelAnimationFrame(popFrame);
    popFrame = requestAnimationFrame(() => {
      if (!pop || pop.hidden || !popTrigger) return;
      if (!popTrigger.isConnected) { closePop(false); return; }
      const r = popTrigger.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) { closePop(false); return; }
      placePop();
    });
  };
  const onScroll = (event) => {
    if (!pop || event.target === pop || pop.contains(event.target)) return;
    follow();
  };
  // Phones fire resize when the address bar shows or hides; only a real width change (rotation) closes the list
  const onResize = () => {
    if (Math.abs(window.innerWidth - popWidth) > 40) { closePop(false); return; }
    follow();
  };

  function placePop() {
    const r = popTrigger.getBoundingClientRect();
    const width = Math.max(r.width, 220);
    pop.style.width = `${width}px`;
    pop.style.left = `${Math.min(Math.max(8, r.left), window.innerWidth - width - 8)}px`;
    const below = window.innerHeight - r.bottom - 8;
    const above = r.top - 8;
    const want = Math.min(pop.scrollHeight, 340);
    if (below >= want || below >= above) {
      pop.style.top = `${r.bottom + 4}px`;
      pop.style.bottom = 'auto';
      pop.style.maxHeight = `${Math.max(160, Math.min(340, below))}px`;
    } else {
      pop.style.top = 'auto';
      pop.style.bottom = `${window.innerHeight - r.top + 4}px`;
      pop.style.maxHeight = `${Math.max(160, Math.min(340, above))}px`;
    }
  }

  function ensurePop() {
    if (pop) return;
    pop = document.createElement('div');
    pop.className = 'bbk-pop';
    pop.setAttribute('role', 'listbox');
    pop.setAttribute('aria-label', 'Choose a print');
    pop.hidden = true;
    document.body.appendChild(pop);
    pop.addEventListener('click', (event) => {
      const option = event.target.closest('.bbk-opt');
      if (!option || option.disabled || !popTrigger) return;
      const row = popTrigger.closest('.kaching-bundles__bar-variant__content');
      const target = row && row.querySelector('select[data-name="Print"]');
      closePop(true);
      pick(target, option.dataset.value);
      paintKaching();
    });
    pop.addEventListener('keydown', (event) => {
      const items = Array.from(pop.querySelectorAll('.bbk-opt:not([disabled])'));
      const i = items.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') { event.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (event.key === 'Home') { event.preventDefault(); items[0].focus(); }
      else if (event.key === 'End') { event.preventDefault(); items[items.length - 1].focus(); }
      else if (event.key === 'Escape' || event.key === 'Tab') { event.preventDefault(); closePop(true); }
    });
  }

  function openPop(trigger) {
    const content = trigger.closest('.kaching-bundles__bar-variant__content');
    const select = content && content.querySelector('select[data-name="Print"]');
    if (!select) return;
    ensurePop();
    if (popTrigger === trigger && !pop.hidden) { closePop(true); return; }
    closePop(false);
    pop.innerHTML = Array.from(select.options).map((o) => {
      const on = o.value === select.value;
      return `<button type="button" class="bbk-opt${on ? ' is-on' : ''}" role="option" aria-selected="${on}" data-value="${attr(o.value)}"${o.disabled ? ' disabled' : ''}><span class="bbk-sw" aria-hidden="true"></span><span class="bbk-opt-name">${attr(o.text)}</span>${on ? TICK : ''}</button>`;
    }).join('');
    pop.querySelectorAll('.bbk-opt').forEach((b) => setPhoto(b.querySelector('.bbk-sw'), b.dataset.value));
    popTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    pop.hidden = false;
    placePop();
    const current = pop.querySelector('.bbk-opt.is-on') || pop.querySelector('.bbk-opt');
    if (current) {
      const top = current.offsetTop - (pop.clientHeight - current.offsetHeight) / 2;
      pop.scrollTop = Math.max(0, top);
      // Focusing on a phone can make the browser scroll the page, so only keyboard/mouse users get focus moved
      if (!touchScreen()) current.focus({ preventScroll: true });
    }
    popWidth = window.innerWidth;
    document.addEventListener('click', onOutside, true);
    document.addEventListener('keydown', onEscape, true);
    window.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onResize, { passive: true });
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest) return;
    const trigger = event.target.closest('.bbk-print');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openPop(trigger);
      return;
    }
    const sizeButton = event.target.closest('.bbk-size');
    if (sizeButton && !sizeButton.disabled) {
      event.preventDefault();
      event.stopPropagation();
      const row = sizeButton.closest('.kaching-bundles__bar-variant__content');
      pick(row && row.querySelector('select[data-name="Size"]'), sizeButton.dataset.value);
      paintKaching();
    }
  }, true);

  // Arrow keys move between S / M / L like radio buttons
  document.addEventListener('keydown', (event) => {
    const button = event.target.closest && event.target.closest('.bbk-size');
    if (!button || !/^Arrow(Left|Right|Up|Down)$/.test(event.key)) return;
    event.preventDefault();
    const all = Array.from(button.parentElement.querySelectorAll('.bbk-size:not([disabled])'));
    const step = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
    const next = all[(all.indexOf(button) + step + all.length) % all.length];
    if (next) { next.click(); next.focus(); }
  });

  /* ---------- long-form offer boxes ---------- */
  function paintLongForm() {
    document.querySelectorAll('select[data-print]').forEach((select) => {
      Array.from(select.options).forEach((option) => {
        if (!option.dataset.img || option.dataset.img.charAt(0) === '/') option.dataset.img = fileUrl(option.value);
      });
      const swatch = select.parentElement && select.parentElement.querySelector('[data-swatch]');
      const option = select.options[select.selectedIndex];
      const value = option ? `url("${option.dataset.img}")` : '';
      if (swatch && option && swatch.style.getPropertyValue('--sw') !== value) swatch.style.setProperty('--sw', value);
    });
  }

  /* ---------- keep everything in step ---------- */
  const paintNow = () => { paintKaching(); paintLongForm(); };
  let queued = false;
  const paint = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; paintNow(); }, 30);
  };

  paintNow();
  document.addEventListener('DOMContentLoaded', paintNow);
  document.addEventListener('change', (event) => {
    if (event.target && event.target.matches && event.target.matches('select[data-name="Print"], select[data-name="Size"], select[data-print]')) paint();
  }, true);
  // Kaching draws its picker after the page loads and redraws rows when the pack changes.
  // Only repaint for changes in or around the pickers, not for every countdown tick elsewhere on the page.
  const PICKERS = '.kaching-bundles, bbl-pack, select[data-print]';
  const relevant = (records) => records.some((m) => {
    const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (!el || (pop && pop.contains(el))) return false;
    if (el.closest(PICKERS)) return true;
    return Array.from(m.addedNodes).some((n) => n.nodeType === 1 && (n.matches(PICKERS) || !!n.querySelector(PICKERS)));
  });
  const observer = new MutationObserver((records) => { if (relevant(records)) paint(); });
  const watch = () => observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-value'] });
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
